/* eslint-disable quotes,quote-props */
import ApiService from './api.service';

export default {
  getVisitPossibleSurveys(visitId) {
    return ApiService.get(`appointments/${visitId}/additional`);
  },
  getSurveyDetails(surveyId) {
    return ApiService.get(`forms/${surveyId}`);
  },
  addSuveryToVisit(visitId, surveyId) {
    return ApiService.post(`appointments/${visitId}/forms`, {
      "formIds": surveyId,
    });
  },
  deleteSuveryFromVisit(visitId, surveyId) {
    return ApiService.delete(`appointments/${visitId}/forms/${surveyId}`);
  },
  getVisitSurveys(visitId) {
    return ApiService.get(`appointments/${visitId}/forms`);
  },
  setSurveyFieldValue(visitId, fieldId, value) {
    return ApiService.post(`appointments/${visitId}/forms/${fieldId}/values`, {
      "value": value,
    });
  },
  updateSurveyFieldValue(visitId, fieldId, value) {
    return ApiService.put(`appointments/${visitId}/forms/${fieldId}/values`, {
      "value": value,
    });
  },
  deleteSurveyFieldValue(visitId, fieldId, index) {
    return ApiService.delete(`appointments/${visitId}/forms/${fieldId}/values`, {
      "index": index,
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/survey.service.js